import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class Whatsapper {

  private readonly SendToNumber = environment.AppConfig.Whatsapp.SendToNumber;
  private readonly WhatsAppApiUrl = `https://wa.me/${this.SendToNumber}/?text=`;

  sendWhatsApp(message: string) {
    message = encodeURI(message);
    const url = `${this.WhatsAppApiUrl}${message}`;
    window.open(url, '_blank');
  }
}
